import { Text } from '../Text/Text';
import styles from './CoachExpertise.module.scss';

interface CoachExpertiseProps {
  expertise: string;
}

const CoachExpertise = ({ expertise }: CoachExpertiseProps) => {
  return (
    <div className={styles.expertise}>
      <Text.Regular>{expertise}</Text.Regular>
    </div>
  );
};

export default CoachExpertise;
